import * as React from 'react';

type EventProp<E extends string, A extends any[]> = {
    [key in E]: (...args: A) => void;
};

type ChildEventProp <E extends string, A extends any[]> = {
    children?: React.ReactElement<ChildEventProp<E, A>> | React.ReactElement<ChildEventProp<E, A>>[];
} & EventProp<E, A>;

/**
 * Bubble down an event through a node's children until the depth reaches max or a child node with the event is hit.
 */
export function bubbleDownEvent<E extends string, A extends any[]>(
    eventName: E,
    eventArgs: A,
    node: React.ReactElement<ChildEventProp<E, A>>,
    depth: number
): void {
    if (depth < 0) {
        return;
    }
    if (node?.props?.[eventName]) {
        node.props[eventName](...eventArgs);
    } else if (React.Children.count(node?.props?.children) === 1) {
        const childNode = (React.Children.only(node?.props?.children) as React.ReactElement);
        bubbleDownEvent(eventName, eventArgs, childNode, depth - 1);
    }
}
